/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable prefer-template */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable-next-line react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useTranslate } from 'hooks/useTranslate';

import { getBeneficiaryAmount, getSocietyValue } from 'utils/filters';
import { getTenderOffers } from 'modules/transactions/redux/tenderOfferActions';
import isSuperAdmin from 'utils/isSuperAdmin';
import { useGetActualSociety } from 'hooks/useGetActualSociety';

import { setModal } from 'modules/_shared/redux/modalActions';
import transformData from 'modules/_shared/components/Tables/helpers';
import BeneficiaryRow from 'modules/beneficiaries/components/BeneficiaryRow';
import { useGetMenu } from 'modules/administratives/hooks/useGetMenu';
import { getStockPlans } from 'modules/beneficiaries/redux/planActions';
import DeletePlanBeneficiaries from 'modules/beneficiaries/modals/DeletePlanBeneficiaries';
import { useGetPlanSectionPermissions } from 'modules/beneficiaries/hooks/useGetPlanSectionPermissions';

import hasPlanCustomDilution from 'utils/customDilution';
import useGetBeneficiaryOptions from './useGetBeneficiaryOptions';
import useGetPlan from './useGetPlan';
import menuOptions from '../menuOptions';
import tableColumns from '../tableColumns';
import {
  getMonthsDiff,
  getConsolidationDate,
  getConsolidatedPercent,
  getToVest,
  getMonthsToVest,
  getStrikePrice,
} from '../utils/beneficiaryPlanCalculations';
import { getUnits, getStatus, getStatusName } from '../utils/beneficiaryStatus';
import {
  getPlanName,
  getIncentive,
  getCertificateData,
  getIncentiveValue,
  parseBeneficiaryRowToTable,
} from '../utils/beneficiaryDataFormatters';
import { beneficiaryEligibility } from '../utils/beneficiaryEligibility';

const useBeneficiaryList = () => {
  const { t, i18n } = useTranslate();
  const dispatch = useDispatch();
  const { societyId, planId } = useParams();

  const { isAdmin, isReadOnly } = useGetPlanSectionPermissions().data;

  const user = useSelector((state) => state.user);
  const actualSociety = useSelector((state) => state.society?.actualSociety);
  const plans = useSelector((state) => state.plans);
  const tenderOffers = useSelector((state) => state?.tenderOffers);

  const [societyShares, setSocietyShares] = useState();
  const [rows, setRows] = useState([]);
  const [summaryRow, setSummaryRow] = useState([]);
  const [percentVestedUnits, setPercentVestedUnits] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [rawData, setRawData] = useState([]);
  const [currentTableColumns, setCurrentTableColumns] = useState(
    tableColumns(i18n)
  );
  const [currentMenuOptions, setCurrentMenuOptions] = useState(
    menuOptions(i18n)
  );
  const [pendingInvitations, setPendingInvitations] = useState([]);
  const [societyValue] = useState(getSocietyValue(actualSociety));

  const { currentPlan } = useGetPlan(planId, plans);
  const { currentBeneficiaryOptions } = useGetBeneficiaryOptions(user, i18n);

  const handleDeleteBeneficiaries = () => {
    dispatch(
      setModal(
        <DeletePlanBeneficiaries societyId={societyId} plan={currentPlan} />
      )
    );
  };

  const filterOptions = (beneficiary) => {
    const options = currentBeneficiaryOptions.map((option) => ({ ...option }));
    options[0].url = `/detalle-beneficiario/${societyId}/${beneficiary?.plan}`;
    if (beneficiary?.isCanceled) {
      options[6].text = t('ChangeCancelation');
    }
    if (!isAdmin) {
      if (user['_id'] !== beneficiary.user) options[1].disabled = true;
      options[2].disabled = true;
      options[3].disabled = true;
      options[5].disabled = true;
    }
    return options;
  };

  const getPageDescription = () =>
    `${planId ? getPlanName(planId) : actualSociety?.name} ${t(
      'HaveBeneficiaries',
      { count: rows.length }
    )}`;

  useGetMenu();
  useGetActualSociety(societyId);

  useEffect(() => {
    dispatch(getStockPlans(societyId));
    dispatch(getTenderOffers(societyId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [societyId]);

  useEffect(() => {
    if (actualSociety && plans?.length) {
      const {
        beneficiariesPending,
        beneficiariesTable,
        totalShares,
        decimalScale,
      } = beneficiaryEligibility({
        actualSociety,
        isAdmin,
        user,
        plans,
        currentPlan,
      });

      setSocietyShares(totalShares);
      setPendingInvitations(beneficiariesPending);
      setRows(
        beneficiariesTable?.map((beneficiary, index) => {
          const plan = plans?.find((plan) => plan['_id'] === beneficiary?.plan);
          return (
            <BeneficiaryRow
              beneficiary={beneficiary}
              email={beneficiary?.email}
              sharesCount={beneficiary?.sharesCount}
              society={actualSociety}
              societyId={actualSociety['_id']}
              societyShares={totalShares}
              decimals={decimalScale}
              amount={getBeneficiaryAmount(beneficiary, plan)}
              index={index + 1}
              key={beneficiary['_id']}
              planId={beneficiary?.plan}
              userId={user['_id']}
              documentURL={beneficiary?.documentURL}
              invitationStatus={beneficiary?.invitationStatus}
              user={user}
              isSuperAdmin={isSuperAdmin(user)}
            />
          );
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    actualSociety,
    societyShares,
    user,
    societyId,
    plans,
    planId,
    i18n.language,
  ]);

  useEffect(() => {
    const newData = rows.map(({ props }) => {
      const plan = plans?.find(
        (plan) => plan['_id'] === props.beneficiary?.plan
      );
      return parseBeneficiaryRowToTable({
        props,
        plan,
        plans,
        actualSociety,
        filterOptions,
        currentBeneficiaryOptions,
        isAdmin,
        isReadOnly,
        user,
        t,
        tenderOffers,
      });
    });

    if (newData.length > 0) {
      setTableData(
        transformData({
          data: newData,
          columns: tableColumns(i18n),
        })
      );
      setRawData(newData);
    }

    setSummaryRow(
      newData.reduce(
        (acc, curr) => ({
          units: acc.units + curr.units,
          vestedUnits: acc.vestedUnits + curr.vestedUnits,
          incentiveValue:
            acc.incentiveValue +
            getIncentiveValue(curr.FDpercent, societyValue),
        }),
        {
          units: 0,
          vestedUnits: 0,
          incentiveValue: 0,
        }
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rows, tenderOffers]);

  useEffect(() => {
    setPercentVestedUnits(
      ((summaryRow.vestedUnits / summaryRow.units) * 100).toFixed(2)
    );
  }, [summaryRow]);

  useEffect(() => {
    setCurrentTableColumns(tableColumns(i18n));
    setCurrentMenuOptions(
      menuOptions(i18n).map((option, index) => ({
        ...option,
        disabled: index === 1 && hasPlanCustomDilution(plans),
      }))
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language, plans]);

  return {
    data: {
      currentBeneficiaryOptions,
      currentMenuOptions,
      currentPlan,
      currentTableColumns,
      isAdmin,
      isReadOnly,
      pendingInvitations,
      percentVestedUnits,
      plans,
      rawData,
      rows,
      societyShares,
      societyValue,
      summaryRow,
      tableData,
    },
    actions: {
      filterOptions: (beneficiary) =>
        filterOptions(
          beneficiary,
          currentBeneficiaryOptions,
          societyId,
          isAdmin,
          user,
          t
        ),
      getCertificateData: (beneficiary, planId) =>
        getCertificateData(
          beneficiary,
          planId,
          plans,
          actualSociety,
          societyId
        ),
      getConsolidatedPercent: (beneficiary, planId, date) =>
        getConsolidatedPercent(beneficiary, planId, plans, date),
      getConsolidationDate: (beneficiary, planId) =>
        getConsolidationDate(beneficiary, planId, plans),
      getIncentive: (planId) => getIncentive(planId, plans),
      getIncentiveValue: (FD) => getIncentiveValue(FD, societyValue),
      getMonthsDiff,
      getMonthsToVest: (beneficiary, planId, date) =>
        getMonthsToVest(beneficiary, planId, plans, date),
      getPageDescription: () =>
        getPageDescription(planId, actualSociety, rows, t, plans),
      getPlanName: (planId) => getPlanName(planId, plans),
      getStatus: (beneficiary, planId, date) =>
        getStatus(beneficiary, planId, plans, date),
      getStatusName: (beneficiary, planId, date) =>
        getStatusName(beneficiary, planId, plans, date),
      getStrikePrice: (beneficiary, planId) =>
        getStrikePrice(beneficiary, planId, plans),
      getToVest,
      getUnits,
      handleDeleteBeneficiaries,
    },
    isLoading: !actualSociety,
    isError: false,
  };
};

export default useBeneficiaryList;
